import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './AlertModalStar.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class AlertModalStar extends Component {
    render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isModalOpenStar} toggle={this.toggle}>
		          	<ModalHeader toggle={this.props.toggleAlertModalStar}>{strings.title}</ModalHeader>
		          	<ModalBody>
					  	{this.props.modalDescription}
					</ModalBody>
		          	<ModalFooter className="justify-content-center">
		            	<button 
		            		className="showtix-button showtix-background__grey-1"
                            onClick={this.props.toggleAlertModalStar}
		            		>{strings.cancel}</button>
                        <button 
		            		className="showtix-button showtix-background__primary-3"
                            onClick={this.props.confirmAlertModalStar}
		            		>{strings.print}</button>    
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

AlertModalStar.propTypes = {
    modalTitle: PropTypes.string,
    modalDescription: PropTypes.element,
    isModalOpenStar: PropTypes.bool,
    toggleAlertModalStar: PropTypes.func,
    confirmAlertModalStar: PropTypes.func,
}

export default AlertModalStar;


// WEBPACK FOOTER //
// ./src/components/Common/AlertModalStar/AlertModalStar.js